export const DEFAULT_RECONNECT_TRY_COUNT = 1;
